import { BanCode, BaseResp, ErrorBase } from "@/00-shared/const";

type GenericErrorName =
  | "UNLOGIN_ERROR"
  | "UNKNOWN_ERROR"
  | "PARAMS_ERROR"
  | "TIME_ZONE_ERROR"
  | "DB_ERROR"
  | "BATCH_OUT_OF_LIMIT"
  | "INVALID_RESOURCE"
  | "PASS_THROUGH_ERROR"
  | "WECHAT_CREATE_ORDER_ERROR"
  | "WECHAT_ORDER_QUERY_ERROR"
  | "WECHAT_ORDER_CLOSE_ERROR"
  | "WECHAT_CALLBACK_ERROR"
  | "LOWER_PACKAGE_ERROR"
  | "SUB_ACCOUNT_UNAVAILABLE_ERROR"
  | "SUB_ACCOUNT_AMOUNT_LOWER_ERROR"
  | "HAVING_UNFINISHED_ORDER_ERROR"
  | "BUILD_AUTH_CTX_ERROR"
  | "CASBIN_ERROR"
  | "GET_PARAMS_ERROR"
  | "GET_POLICY_ERROR"
  | "ADD_POLICY_ERROR"
  | "BUILD_CASBIN_CHECKER_ERROR"
  | "USER_NOT_FOUND_ERROR"
  | "SUB_ACCOUNT_AMOUNT_NOT_ENOUGH_ERROR"
  | "USER_HAD_BEEND_ADD_SUB_ACCOUNT_ERROR"
  | "UNAUTHORIZED_ERROR"
  | "OUT_OF_LIMIT_ERROR"
  | "USER_NOT_FOUND_ERROR"
  | "SUB_ACCOUNT_NOT_ENOUGH_ERROR"
  | "SUB_ACCOUNT_HAD_BEEND_ADD_ERROR"
  | "USER_DOES_NOT_HAVE_PHONE_ERROR"
  | "USER_HAS_PAID_ERROR"
  | "USER_HAS_EXIST_ERROR"
  | "INVALID_POLICY_ERROR"
  | "CAPTCHA_REQUIRED_BAN_ERROR"
  | "VOICE_CAPTCHA_REQUIRED_BAN_ERROR"
  | "PERMANENT_BAN_ERROR";

export class GenericError extends ErrorBase<GenericErrorName> {}

export const respCodeCheck = (baseResp: BaseResp) => {
  if (!baseResp) {
    throw new GenericError({ name: "UNKNOWN_ERROR", message: "请联系管理员" });
  }
  switch (baseResp.code) {
    case 0:
      return;
    case 1000:
      return;
    // 通用错误
    case 1001:
      throw new GenericError({
        name: "PARAMS_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 1002:
      throw new GenericError({
        name: "TIME_ZONE_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 1004:
      throw new GenericError({
        name: "DB_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 1005:
      throw new GenericError({
        name: "BATCH_OUT_OF_LIMIT",
        message: "批量操作限制为 50，请减小批量 size",
        baseResp,
      });
    case 1006:
      throw new GenericError({
        name: "INVALID_RESOURCE",
        message: "无效资源",
        baseResp,
      });

    // passthrough 错误
    case 1003:
      throw new GenericError({
        name: "PASS_THROUGH_ERROR",
        message: "请联系管理员",
        baseResp,
      });

    // ---- 子账户相关 -----
    case 2007:
      throw new GenericError({
        name: "USER_NOT_FOUND_ERROR",
        message: "添加失败，该ID不存在",
        baseResp,
      });
    case 2008:
      throw new GenericError({
        name: "SUB_ACCOUNT_AMOUNT_NOT_ENOUGH_ERROR",
        message: "剩余子账户席位不足",
        baseResp,
      });
    case 2009:
      throw new GenericError({
        name: "USER_HAD_BEEND_ADD_SUB_ACCOUNT_ERROR",
        message: "用户已经被添加到某账户",
        baseResp,
      });
    case 2010:
      throw new GenericError({
        name: "USER_DOES_NOT_HAVE_PHONE_ERROR",
        message: "用户没有手机号",
        baseResp,
      });
    case 2011:
      throw new GenericError({
        name: "USER_HAS_PAID_ERROR",
        message: "用户已经付费",
        baseResp,
      });
    case 2012:
      throw new GenericError({
        name: "USER_HAS_EXIST_ERROR",
        message: "用户已经存在",
        baseResp,
      });

    // 支付错误
    case 3001:
      throw new GenericError({
        name: "WECHAT_CREATE_ORDER_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 3002:
      throw new GenericError({
        name: "WECHAT_ORDER_QUERY_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 3003:
      throw new GenericError({
        name: "WECHAT_ORDER_CLOSE_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 3004:
      throw new GenericError({
        name: "WECHAT_CALLBACK_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 3005:
      throw new GenericError({
        name: "LOWER_PACKAGE_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 3006:
      throw new GenericError({
        name: "SUB_ACCOUNT_UNAVAILABLE_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 3007:
      throw new GenericError({
        name: "SUB_ACCOUNT_AMOUNT_LOWER_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 3008:
      throw new GenericError({
        name: "HAVING_UNFINISHED_ORDER_ERROR",
        message: "请联系管理员",
        baseResp,
      });

    // 权限错误
    case 2001:
      throw new GenericError({
        name: "BUILD_AUTH_CTX_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 2002:
      throw new GenericError({
        name: "CASBIN_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 2003:
      throw new GenericError({
        name: "GET_PARAMS_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 2004:
      throw new GenericError({
        name: "GET_POLICY_ERROR",
        message: "请联系管理员",
        baseResp,
      });

    case 2005:
      throw new GenericError({
        name: "ADD_POLICY_ERROR",
        message: "请联系管理员",
        baseResp,
      });

    case 2006:
      throw new GenericError({
        name: "BUILD_CASBIN_CHECKER_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 2007:
      throw new GenericError({
        name: "USER_NOT_FOUND_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 2008:
      throw new GenericError({
        name: "SUB_ACCOUNT_AMOUNT_NOT_ENOUGH_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 2009:
      throw new GenericError({
        name: "USER_HAD_BEEND_ADD_SUB_ACCOUNT_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 2100:
      throw new GenericError({
        name: "UNAUTHORIZED_ERROR",
        message: "请联系管理员",
        baseResp,
      });
    case 2200:
      throw new GenericError({
        name: "OUT_OF_LIMIT_ERROR",
        message: "请联系管理员",
        baseResp,
      });

    case 3009:
      throw new GenericError({
        name: "INVALID_POLICY_ERROR",
        message: "您当前版本不支持升级为企业版，如需升级，请扫码联系客服",
        baseResp,
      });

    // 前端定义错误
    case BanCode.CAPTCHA_REQUIRED_BAN: {
      throw new GenericError({
        name: "CAPTCHA_REQUIRED_BAN_ERROR",
        message: "Forbidden",
        baseResp,
      });
    }
    case BanCode.VOICE_CAPTCHA_REQUIRED_BAN: {
      throw new GenericError({
        name: "VOICE_CAPTCHA_REQUIRED_BAN_ERROR",
        message: "Forbidden",
        baseResp,
      });
    }
    case BanCode.PERMANENT_BAN: {
      throw new GenericError({
        name: "PERMANENT_BAN_ERROR",
        message: "Forbidden",
        baseResp,
      });
    }

    default:
      throw new GenericError({
        name: "UNKNOWN_ERROR",
        message: "请联系管理员",
        baseResp,
      });
  }
};
